import {
  getGridDateOperators,
  GridCellParams,
  GridFilterOperator,
  type GridFilterItem,
  type GridColDef,
} from '@mui/x-data-grid-pro'
import { isValid } from 'date-fns'
let _multDateOps: GridFilterOperator[]
export default function getGridMultiDateOperators() {
  if (!_multDateOps)
    _multDateOps = getGridDateOperators().map((operator) =>
      operator.value === 'isEmpty' || operator.value === 'isNotEmpty'
        ? {
            ...operator,
          }
        : {
            ...operator,
            getApplyFilterFn: (
              filterItem: GridFilterItem,
              column: GridColDef,
            ) => {
              const singleDateFilterFn = operator.getApplyFilterFn(
                filterItem,
                column,
              )
              // if there is not a filter value being applied to the column return true
              if (!filterItem.value || !singleDateFilterFn) return () => true
              return (
                params: GridCellParams<any,
                  Array<Date | null | undefined> | null | undefined
                >,
              ) => {
                if (!params.value) return false
                const validParams = {
                  ...params,
                  value: params.value.filter((v) => v && isValid(v)),
                }
                if (validParams.value.length > 0) {
                  return validParams.value.some((v) =>
                    singleDateFilterFn({ ...params, value: v || undefined }),
                  )
                }
                return false
              }
            },
          },
    )
  return _multDateOps
}
